export default function(client) {
  const walletClient = client.wallet()
  const claimClient = client.claim()

  const state = {
    order: null,
    claimInfo: {},
    claimMessage: "",
    checkingClaim: false
  }

  const actions = {
    async getClaimInfo({ commit }, partnerSlug) {      
      const claimInfo = await claimClient.claimInfo(partnerSlug)
      commit('setClaimInfo', claimInfo)
      return claimInfo
    },
    async checkClaim({ commit }, {partnerSlug, tokenId}) {
      if(!tokenId) {
        return
      }
      
      commit('setCheckingClaim', true)
      commit('setClaimMessage', "checking...")
      const isClaimed = await claimClient.isTokenClaimed(partnerSlug, tokenId)
      commit('setCheckingClaim', false)
      const claimMessage = isClaimed
        ? `Rewards for ${tokenId} are available!`
        : `Rewards for ${tokenId} are unavailable.`
      commit('setClaimMessage', claimMessage)
    },
    async getAvailableClaims({commit}, {partnerSlug, ethAddress}) {
      const availableClaims = await claimClient.availableClaims(partnerSlug, ethAddress)
      commit('setAvailableClaims', availableClaims)
      return availableClaims
    },
    async claimTokens(_store, {partnerSlug, claimInfo}) {
      const claimResult = await claimClient.claimTokens(partnerSlug, claimInfo)
      return claimResult
    }
  }

  const mutations = {
    setNonce(state, nonce) {
      state.nonce = nonce
    },
    setClaimInfo(state, claimInfo) {
      state.claimInfo = claimInfo
    },
    setCheckingClaim(state, checkingClaim) {
      state.checkingClaim = checkingClaim
    },
    setClaimMessage(state, claimMessage) {
      state.claimMessage = claimMessage
    },
    setAvailableClaims(state, availableClaims) {
      state.availableClaims = availableClaims
    }
  }

  const getters = {
  }

  return {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
  }
}
